'use strict';

var React = require('react');

var SvgInsertDynamicSourceMajor = function SvgInsertDynamicSourceMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9 7c4.418 0 8-1.343 8-3s-3.582-3-8-3-8 1.343-8 3 3.582 3 8 3Zm2.224 1.883a7 7 0 0 0-1.934 3.115l-.29.002c-4.418 0-8-1.343-8-3 0-.546.39-1.059 1.07-1.5 1.384.897 3.969 1.5 6.93 1.5.772 0 1.518-.041 2.224-.117Zm-2.224 5.117c0 1.07.24 2.083.669 2.99-.22.007-.444.01-.669.01-4.418 0-8-1.343-8-3 0-.546.39-1.059 1.07-1.5 1.384.897 3.969 1.5 6.93 1.5Zm7 4a1 1 0 0 1-1-1v-2h-2a1 1 0 1 1 0-2h2v-2a1 1 0 1 1 2 0v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 0 1-1 1Z"
  }));
};

exports.SvgInsertDynamicSourceMajor = SvgInsertDynamicSourceMajor;
